module.exports = __webpack_public_path__ + "media/images/icons/marker-1d480c764825b522c2480abc3d45db9b.svg";